/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which split should I use?`)
};

const es_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué reparto debería usar?`)
};

const de_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Verteilung sollte ich verwenden?`)
};

const nl_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke verdeling moet ik gebruiken?`)
};

const fr_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle répartition dois-je utiliser ?`)
};

const it_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale ripartizione dovrei usare?`)
};

const pt_br2_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual divisão devo usar?`)
};

const pt_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que divisão devo usar?`)
};

const ja_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの配分を使うべきですか?`)
};

const zh_macro_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我该用哪种配比？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_faq_q3", locale)
	if (locale === "en") return en_macro_faq_q3(inputs)
	if (locale === "es") return es_macro_faq_q3(inputs)
	if (locale === "de") return de_macro_faq_q3(inputs)
	if (locale === "nl") return nl_macro_faq_q3(inputs)
	if (locale === "fr") return fr_macro_faq_q3(inputs)
	if (locale === "it") return it_macro_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_macro_faq_q3(inputs)
	if (locale === "pt") return pt_macro_faq_q3(inputs)
	if (locale === "ja") return ja_macro_faq_q3(inputs)
	return zh_macro_faq_q3(inputs)
};